import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Team} from 'orgs/OrganizationConstants';

import {TeamGraphQL} from '../../../../graphql-fragments/parties/__generated/TeamGraphQL';

export const TEAM: Team = {
  admin: false,
  autoProvisionedCapabilities: [],
  avatar_url: '/static/img/no_avatar.jpg',
  description: "We engineer vectors using Benchling's better and faster tools.",
  handle: 'Vector Engineering',
  id: 'team_Wi1PWBhb',
  member: true,
  memberCount: 1,
  name: 'Vector Engineering',
  isSchemaAdmin: false,
  organizationId: 'ent_SeQuA2pK',
  type: ModelTypeConstants.TEAM,
};

export const TEAM_GQL: TeamGraphQL = {
  __typename: 'TeamNode',
  id: TEAM.id,
  name: TEAM.name,
  handle: TEAM.handle,
  avatarUrl: TEAM.avatar_url,
};

export const TEAM_2: Team = {
  admin: true,
  autoProvisionedCapabilities: [],
  avatar_url: '/static/img/no_avatar.jpg',
  description: 'We science proteins.',
  handle: 'Protein Sciences',
  id: 'team_pS29NDks',
  member: true,
  memberCount: 2,
  name: 'Protein Sciences',
  isSchemaAdmin: true,
  organizationId: 'ent_SeQuA2pK',
  type: ModelTypeConstants.TEAM,
};

export const TEAM_2_GQL: TeamGraphQL = {
  __typename: 'TeamNode',
  id: TEAM_2.id,
  name: TEAM_2.name,
  handle: TEAM_2.handle,
  avatarUrl: TEAM_2.avatar_url,
};

export const TEAM_3: Team = {
  admin: true,
  autoProvisionedCapabilities: [],
  avatar_url: '/static/img/no_avatar.jpg',
  description: 'We science genetics.',
  handle: 'Genetic Sciences',
  id: 'team_ab45sEY4',
  member: true,
  memberCount: 2,
  name: 'Genetic Sciences',
  isSchemaAdmin: true,
  organizationId: 'ent_SeQuA2pK',
  type: ModelTypeConstants.TEAM,
};

export const TEAM_3_GQL: TeamGraphQL = {
  __typename: 'TeamNode',
  id: TEAM_3.id,
  name: TEAM_3.name,
  handle: TEAM_3.handle,
  avatarUrl: TEAM_3.avatar_url,
};
